
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 431 311"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"レイヤー 2"}},[_c('g',{attrs:{"data-name":"レイヤー 1"}},[_c('path',{attrs:{"fill":"#c04d00","opacity":".2","d":"M233.139 146.337l8.999-3.142-2.74-4.182-6.259 7.324zM258.174 123.878l-.793 3.352 3.461.72-.721 3.462 3.736 1.139-.554 3.716 69.005-45.217-8.89-13.566-69.005 45.217 3.761 1.177z"}}),_c('path',{attrs:{"fill":"none","stroke":"#6b4000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M240.494 140.686l-6.259 7.324 8.999-3.142 21.165-6.928 69.005-45.217-8.889-13.566-69.005 45.217-15.016 16.312zM243.234 144.868l-2.74-4.182"}}),_c('path',{attrs:{"fill":"none","stroke":"#6b4000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","d":"M264.399 137.94l.554-3.716-3.736-1.14.721-3.461-3.461-.721.793-3.351-3.76-1.177"}}),_c('path',{attrs:{"d":"M272.864 102.849l-6.619-19.667s-52.3-19.951-76 25.819c0 0-46.935-28.966-87.37 32.3l48.613 99.161s24.015-53.827 79.3-38.693c0 0 18.648-33.426 71.283-12.172l-19.778-58.764","fill":"none","stroke":"#6b4000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M106.673 149.021a97.767 97.767 0 00-6.55 9.061l48.613 99.16s23.334-62.044 78.615-46.911c0 0 16.376-34.272 69.011-13.018l-3.318-10.676","fill":"none","stroke":"#6b4000","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"fill":"none","d":"M0 0h431v311H0z"}})])])])
          )
        }
      }
    